import { getSelectedTableView, getListViewState, MailRowDataPropertyGetter } from "owa-mail-list-store";
import type { ActionSource } from "owa-analytics-types";
import { lazyPrintConversation, lazyPrintItem } from "owa-mail-message-actions";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { resetFocus } from "owa-mail-focus-manager";
import getExpandedItemId from "../utils/getExpandedItemId";
import { getActiveContentTab, TabType } from "owa-tab-store";
import { isReadingPaneStackedView } from "owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils";

export default function onPrint(actionSource: ActionSource, targetWindow?: Window): void {
    const printStartTime = Date.now();
    // If there is an active secondary tab, print from there
    const activeTab = getActiveContentTab();
    if (activeTab && activeTab.type === TabType.SecondaryReadingPane) {
        const secondaryReadingPaneTabData = activeTab.data;
        const itemOrConversationId = secondaryReadingPaneTabData.id;
        switch (secondaryReadingPaneTabData.listViewType) {
            case 0:
                if (!isReadingPaneStackedView(undefined /*listViewType*/)) {
                    lazyPrintItem.importAndExecute(itemOrConversationId /* itemId */, actionSource, targetWindow, printStartTime);
                }
                else {
                    lazyPrintConversation.importAndExecute(itemOrConversationId /* conversationId */, actionSource, targetWindow, printStartTime);
                }
                break;
            case 1:
                lazyPrintItem.importAndExecute(itemOrConversationId /* itemId */, actionSource, targetWindow, printStartTime);
                break;
        }
    }
    else {
        const tableView = getSelectedTableView();
        
        const nodeIds = getListViewState().expandedConversationViewState.selectedNodeIds;
        if (nodeIds.length === 1) {
            const clientItemId = getExpandedItemId(tableView, nodeIds);
            lazyPrintItem.importAndExecute(clientItemId /* itemId */, actionSource, targetWindow, printStartTime);
        }
        else {
            const rowKeys = [...tableView.selectedRowKeys.keys()];
            const selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKeys[0], tableView);
            switch (tableView.tableQuery.listViewType) {
                case 0:
                    lazyPrintConversation.importAndExecute(selectedRowId /* conversationId */, actionSource, targetWindow, printStartTime);
                    break;
                
                case 1:
                    lazyPrintItem.importAndExecute(selectedRowId /* itemId */, actionSource, targetWindow, printStartTime);
                    break;
            }
        }
    }
    
    resetFocus("printCommand");
}
